"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_STALE_WARNING_BATCH_VERSION = exports.CHEMKIT_STALE_WARNING_BATCH_EVENT = void 0;
exports.isChemkitStaleNotificationId = isChemkitStaleNotificationId;
exports.isChemkitStaleWarningBatchDetail = isChemkitStaleWarningBatchDetail;
exports.CHEMKIT_STALE_WARNING_BATCH_EVENT = "chemkit.stale-warning.batch";
exports.CHEMKIT_STALE_WARNING_BATCH_VERSION = 1;
const CHEMKIT_STALE_NOTIFICATION_ID_PATTERN = /^ck-.+__(?:reaction|sample)__\d+__\d+$/;
function isChemkitStaleNotificationId(value) {
    return typeof value === "string" && CHEMKIT_STALE_NOTIFICATION_ID_PATTERN.test(value);
}
function isChemkitStaleWarningBatchDetail(value) {
    if (!value || typeof value !== "object")
        return false;
    const detail = value;
    if (detail.version !== exports.CHEMKIT_STALE_WARNING_BATCH_VERSION || !Array.isArray(detail.warnings)) {
        return false;
    }
    return detail.warnings.every((warning) => {
        if (!warning || typeof warning !== "object")
            return false;
        const candidate = warning;
        return (isChemkitStaleNotificationId(candidate.notificationId) &&
            (candidate.entityKind === "reaction" || candidate.entityKind === "sample") &&
            typeof candidate.entityId === "number" &&
            Number.isInteger(candidate.entityId) &&
            candidate.entityId > 0);
    });
}
